import {
	formatHhMmFromTotalSeconds,
	formatHoursOnlyHhMmFromTotalSeconds,
} from "common/src/utils/dateTimeFormatUtils";
import { _ } from "i18n";
import { DISCOVER_GAMES_DURATION_CAP_OPTIONS } from "../constants";
import type { GameRow } from "../types";

/**
 * Read-only Analysis SLA cell. Backend ships:
 * - `analysisSlaHours`: SLA bucket in seconds (NULL when priority = 0).
 * - `analysisSla`: signed delta `turnaround - sla` in seconds (NULL when priority = 0 or analysis is not finished).
 */
export function DiscoverGamesAnalysisSlaCell({ row }: { row: GameRow }) {
	const slaSecondsRaw = row.analysisSlaHours;
	const deltaRaw = row.analysisSla;

	const slaSeconds =
		typeof slaSecondsRaw === "number"
			? slaSecondsRaw
			: typeof slaSecondsRaw === "string" && slaSecondsRaw !== ""
				? Number(slaSecondsRaw)
				: null;

	if (slaSeconds === null || !Number.isFinite(slaSeconds)) {
		return <div className="thinCell">-</div>;
	}

	const delta =
		typeof deltaRaw === "number"
			? deltaRaw
			: typeof deltaRaw === "string" && deltaRaw !== ""
				? Number(deltaRaw)
				: null;

	if (delta === null || !Number.isFinite(delta)) {
		return (
			<div className="thinCell discoverGamesTableV3-analysisSlaPending">
				{formatHoursOnlyHhMmFromTotalSeconds(slaSeconds, DISCOVER_GAMES_DURATION_CAP_OPTIONS)}{" "}
				{_("discover.gamesTable.cellValue.analysisSla.pending")}
			</div>
		);
	}

	const isLate = delta > 0;
	const sign = isLate ? "+" : delta < 0 ? "-" : "";
	const label = `${sign}${formatHhMmFromTotalSeconds(Math.abs(delta), DISCOVER_GAMES_DURATION_CAP_OPTIONS)}`;
	const className = isLate
		? "discoverGamesTableV3-analysisSlaLate"
		: "discoverGamesTableV3-analysisSlaEarly";
	return <div className={`thinCell ${className}`}>{label}</div>;
}
